import Button from "@base/Button/Button";

export default Button;
